export const systemEndpoints = {
  serverTs: '/api/system/time',
  checkImportingSale: '/api/system/check-importing-sale',
};
